/*eslint-disable */
import ppLeftSidebar from './left-sidebar-rp';
export default {
  name: 'awerack-root',
  components: {
    'pp-left-sidebar' : ppLeftSidebar,
  },
  props: [],
  data () {
    return {
      isMobile:false,
      mblLeftSidebaar:false
    }
  },
  computed: {

  },
  mounted () {

  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
  }
}